import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { PLACEHOLDER } from 'components/column-renderers'
import { CSVField } from 'hooks/useExportCSV'
import { TraineeTeamRole } from 'types'
import { TeamRoleCell } from '../components/TeamRoleCell/TeamRoleCell'
import { getRolesList } from './Team.model'

export const createTeamRoleColumn = (): ColDef => {
  return {
    headerName: 'Role',
    field: 'role',
    minWidth: 300,
    sortable: false,
    cellRenderer: (
      props: ICellRendererParams<{
        role: TraineeTeamRole[]
        otherRole: string
      }>,
    ) => {
      if (!props.data) return PLACEHOLDER

      const { role, otherRole } = props.data
      return <TeamRoleCell roles={getRolesList(role, otherRole)} />
    },
  }
}

export const createTeamRoleCsvColumn = (): CSVField => {
  return {
    label: 'Role',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: (data: any) => {
      if (!data) return PLACEHOLDER

      const { role, otherRole } = data
      const roles = getRolesList(role, otherRole)
      if (roles.length === 0) return PLACEHOLDER

      return roles.join(', ')
    },
  }
}
